import { LayoutDashboard, Menu } from "lucide-react";
import logoMain from "assets/images/logos/logo-main.svg";

export const BoDashboardMenuLogo: React.FC<{
  isCollapsed: boolean;
  onToggle: () => void;
}> = ({ isCollapsed, onToggle }) => {

  return (
    <div
      className={`absolute
    ${isCollapsed ? 'w-24 h-24' : 'w-max -left-2.5 -top-2.5'}
`}
    >
      {/* Logos complets quand le menu est ouvert */}
      {!isCollapsed && (
        <>
          <img
            className="w-full h-full object-contain block max-w-full"
            src={logoMain}
            alt="logo"
          />
          <div className="absolute cursor-pointer top-7 left-7 flex items-center gap-2">
            {/* Icône */}
            <div className="bg-secondary p-1 rounded-lg">
              <LayoutDashboard className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <span className="text-4xl tracking-tighter leading-none">
              <span className="text-primary font-semibold">
                Back
              </span>
              <span className="text-secondary font-semibold">
                office
              </span>
            </span>
          </div>
        </>
      )}
      {/* Icône seule quand le menu est fermé */}
      {isCollapsed && (
        <div className="cursor-pointer text-white/70 hover:text-white h-full flex items-center justify-center"
          onClick={onToggle}
        >
          <Menu size={24} className="text-current" />
        </div>
      )}
    </div>
  );
};
